<template>
    <div class="pagerwrap">
        <div v-if="totalLength === 0" class="nomessages">{{myT('noMessages')}}</div>
        <div v-else>
            <span class="info">
                <span v-if="pageLength === 1 || this.actualLength === 1">
                    <span v-if="filteredLength === -1">
                        {{myT('currentPositionSingle',
                            { start: start + 1, total: totalLength })}}
                    </span>
                    <span v-else>
                        {{myT('currentPositionFilteredSingle',
                            { start: start + 1, total: totalLength, filteredLength })}}
                    </span>
                </span>
                <span v-else>
                    <span v-if="filteredLength === -1">
                        {{myT('currentPosition',
                            { start: start + 1, end: Math.min(start + actualLength, totalLength),
                            total: totalLength })}}
                    </span>
                    <span v-else>
                        {{myT('currentPositionFiltered',
                            { start: start + 1, end: Math.min(start + actualLength, totalLength),
                            total: totalLength, filteredLength })}}
                    </span>
                </span>
            </span>
            <icon-button icon="chevron-left"
                @click="previousPage" :disabled="start === 0"
                :title="myT('previous')"/>
            <icon-button icon="chevron-right"
                    @click="nextPage" :disabled="start >= (visibleLength - pageLength)"
                    :title="myT('next')"/>

        </div>
    </div>
</template>

<script>
import IconButton from '@/components/iconButton';

export default {
  name: 'messagePager',
  components: { IconButton },
  props: {
    start: {
      type: Number,
      default: 0
    },
    pageLength: {
      type: Number,
      default: 50
    },
    actualLength: {
      type: Number,
      default: 50
    },
    totalLength: {
      type: Number,
      required: true
    },
    filteredLength: {
      type: Number,
      default: -1
    },
    selectedUIDs: Object
  },
  methods: {
    previousPage() {
      this.$emit('page', Math.max(0, this.start - this.pageLength));
    },
    nextPage() {
      const next = this.start + this.pageLength;
      if (next < this.visibleLength) {
        this.$emit('page', next);
      }
    },
    myT(n, options) {
      return this.$t(`${this.keyPrefix}.${n}`, options);
    }
  },
  computed: {
    visibleLength() {
      return this.filteredLength === -1 ? this.totalLength : this.filteredLength;
    },
    selectCount() {
      return Object.keys(this.selectedUIDs).length;
    },
    keyPrefix() {
      if (this.$mq === 'sm') {
        return 'messageList.pagerShort';
      } else {
        return 'messageList.pager';
      }
    }
  }
};
</script>

<style scoped lang="scss">
    @import '../assets/bootstrap-style.scss';

    .pagerwrap {
        flex: 0 0 auto;
        display: flex;
        padding: 10px 0 10px 0;
        // border-top: 1px solid $gray-300;
        // border-bottom: 1px solid $control-bar-border;
        height: 100%;
        font-size: 1rem;

        .nomessages {
            padding: 0 10px;
        }
    }

    .info {
        flex: 0 0 auto;
    }

    .pager1-todelete {
        flex: 0 0 40px;
        padding: 5px;
        margin: 0 0 0 20px;
        transition: background-color 0.3s;
        border-radius: 0.5em;
        color: $gray-400;
        &.enabled {
            cursor: pointer;
            color: $black;
            &:hover {
                background-color: $gray-300;
            }
        }
    }

    .selectCount {
        display: inline-block;
    }

</style>
